
// native
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// service
import { LocalStorageService } from './local-storage.service';

// model
import { IAppConfig } from '../../models';

// constants
import { AUTOUPDATEBIB_KEY, HYPERLINKS_MODE_KEY, DEFAULT_LOCALE, DEFAULT_LANGUAGE } from '../../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class GlobalsService {

  currentTab$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  initialLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  appConfig: IAppConfig;

  isSectionsModeOn: boolean = false;
  language = DEFAULT_LANGUAGE;
  locale = DEFAULT_LOCALE;

  constructor(
    private localStorageService: LocalStorageService
  ) { }

  navigateToTab(tabNumber: number) {
    this.currentTab$.next(tabNumber);
  }

  setAppConfig(config: IAppConfig) {
    this.appConfig = {
      addCitation: config.addCitation,
      updateCitation: config.updateCitation,
      updateBibliography: config.updateBibliography,
      clearCitationQueueOnAddUpdate: config.clearCitationQueueOnAddUpdate,
      getCitations: config.getCitations,
      getBiblioMeta: config.getBiblioMeta,
      convertLegacy: config.convertLegacy,
      convertToPlainText: config.convertToPlainText,
      convertFromEndnote: config.convertFromEndnote,
      convertFromQuosa: config.convertFromQuosa,
      openLogin: config.openLogin,
      openTutorial: config.openTutorial,
      reloadAddon: config.reloadAddon,
      getVersion: config.getVersion,
      defaultAutoUpdate: config.defaultAutoUpdate,
      environment: config.environment,
      buildVersion: config.buildVersion,
      buildTime: config.buildTime
    };
  }

  get isBibliographyAutoUpdateOn(): boolean {
    const storedAutoUpdate = this.localStorageService.getByKey(AUTOUPDATEBIB_KEY);
    return storedAutoUpdate === null ? this.appConfig?.defaultAutoUpdate : storedAutoUpdate;
  }

  get isHyperlinksModeOn(): boolean {
    const storedHyperlinksMode = this.localStorageService.getByKey(HYPERLINKS_MODE_KEY);
    return storedHyperlinksMode === null ? false : storedHyperlinksMode;
  }

  toggleAutoBibliographyUpdate() {
    this.localStorageService.save(AUTOUPDATEBIB_KEY, !this.isBibliographyAutoUpdateOn);
  }

  toggleHyperlinksMode() {
    this.localStorageService.save(HYPERLINKS_MODE_KEY, !this.isHyperlinksModeOn);
  }
}